export const environment = {
  production: true,
  apiUrl: 'https://restapi.cheggout.com/api/v1.0/',
  rewardUrl: 'https://forms.cheggout.com/rewards-form/',
  apiUrlV4: 'https://restapi.cheggout.com/api/v1.4/',
};
